// subscribePresenceGoalChannel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe presence goal channel
 * @kind action
 * @param {string} {goalId} - goal id.
 * @param {string} {userId} - user id.
 * @return {Promise} Action promise.
 */
const subscribePresenceGoalChannel =
  ({ goalId, userId }) =>
  async dispatch => {
    if (!goalId || !userId) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.SUBSCRIBE_PRESENCE_GOAL_CHANNEL,
      payload: {
        goalId,
        userId,
      },
    });
  };

export default subscribePresenceGoalChannel;
